import { render } from "./permission-btn.vue?vue&type=template&id=3eea647a"
import script from "./permission-btn.vue?vue&type=script&lang=js"
export * from "./permission-btn.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__